import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VendorType } from "@utils/Constants";

interface DataSlice {
  nhisCrawlInfo: {
    cookiesJSON: Optional<JSON>;
    additionalData: any;
    authToken: Optional<string>;
  };

  analyzedData: any;
}

const initialState = (): DataSlice => {
  return {
    nhisCrawlInfo: {
      cookiesJSON: null,
      additionalData: null,
      authToken: null,
    },
    analyzedData: null,
  };
};

export type DoAuthActionType = PayloadAction<{
  onSuccess: (param: any) => any;
  onError: (e: Error) => any;
  authType: VendorType;
  userInfo: {
    name: string;
    phone: string;
    birthday: string;
  };
}>;

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setNHISCrawlData: (
      state,
      action: PayloadAction<{
        cookiesJSON: Optional<JSON>;
        additionalData: any;
        authToken: Optional<string>;
      }>
    ) => {
      state.nhisCrawlInfo.cookiesJSON = action.payload.cookiesJSON;
      state.nhisCrawlInfo.additionalData = action.payload.additionalData;
      state.nhisCrawlInfo.authToken = action.payload.authToken;
    },
    setAnalyzedData: (state, action) => {
      state.analyzedData = action.payload;
    },
    startAuth: (_, _action: DoAuthActionType) => {},
    afterAuth: (_, _action: DoAuthActionType) => {},
  },
});

export const { setNHISCrawlData, setAnalyzedData, startAuth, afterAuth } =
  dataSlice.actions;

export default dataSlice.reducer;
